var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"single-bar-chart",style:({height: _vm.chartHeight, width: _vm.chartWidth})})
}
var staticRenderFns = []

export { render, staticRenderFns }